import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { CollectionsList } from "./CollectionsList";
import CollectionsCreate from "./CollectionsCreate";
import CollectionsEdit from "./CollectionEdit";
import CollectionsDetailPage from "./CollectionsDetailPage";
import { RouteGuard } from "../../guards/RouteGuard";
import { RoleEnum, RoleGroups } from "../../types/RoleEnum";
function Collections() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                    RoleEnum.DISTRIBUTOR,
                    RoleEnum.COLLECTIONS_ADMINISTRATOR,
                ] },
                React.createElement(CollectionsList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: RoleGroups.COLLECTION_EDITOR_ROLES },
                React.createElement(CollectionsCreate, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: RoleGroups.COLLECTION_EDITOR_ROLES },
                React.createElement(CollectionsEdit, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/detail/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [
                    RoleEnum.AGENCY_WORKER,
                    RoleEnum.PUBLISHER_GUARANTOR,
                    RoleEnum.PUBLISHER_ADMIN,
                    RoleEnum.DISTRIBUTOR,
                    RoleEnum.COLLECTIONS_ADMINISTRATOR,
                ] },
                React.createElement(CollectionsDetailPage, null))); } })));
}
export default Collections;
